import Layout from "layout/Layout";
import DateRangeSelector from "pages/dashboard-overview/components/DateRangeSelector";
import useHttp from "hooks/useHttp";
import useAnalyticsFilters from "hooks/useAnalyticsFilters";
import AttributionDashboard from "./components/AttributionDashboard";
import AttributionBreakdownTables from "./components/AttributionBreakdownTables";
import DestinationBreakdownTable from "./components/DestinationBreakdownTable";
import UnattributedRevenueAlert from "./components/UnattributedRevenueAlert";
import UtmBreakdownTables from "./components/UtmBreakdownTables";

export default function AttributionPage() {
  const api = useHttp();
  const { filters, dateRange, setDateRange, customRange, setCustomRange } =
    useAnalyticsFilters("thisMonth");

  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Attribution</h1>

      <div className="mb-4 flex flex-col gap-4 sm:flex-row sm:justify-between">
        <DateRangeSelector
          selected={dateRange}
          onChange={setDateRange}
          customRange={customRange}
          onCustomRangeChange={setCustomRange}
        />
      </div>

      <UtmBreakdownTables api={api} filters={filters} />
      <AttributionBreakdownTables api={api} filters={filters} />
      <DestinationBreakdownTable api={api} filters={filters} />
      <AttributionDashboard api={api} filters={filters} />
      <UnattributedRevenueAlert api={api} filters={filters} />
    </Layout>
  );
}
